import { render, staticRenderFns } from "./DSLabel.vue?vue&type=template&id=b82df1d6&scoped=true&"
import script from "./DSLabel.vue?vue&type=script&lang=js&"
export * from "./DSLabel.vue?vue&type=script&lang=js&"
import style0 from "./DSLabel.vue?vue&type=style&index=0&id=b82df1d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82df1d6",
  null
  
)

export default component.exports